<div class="card-scene">
  <div class="card-3d" [class.is-flipped]="$flipped()">

    <div class="card-face card-front">
      <div class="card-top">
        <div class="chip"></div>
        <ion-icon name="wifi-outline" class="contactless"></ion-icon>
        @if($brandLogo()){
        <img class="brand" [src]="$brandLogo()" alt="" />
        }
      </div>

      <div class="card-number" aria-hidden="true">
        @for(group of $groups(); track $index){
        <span class="group">{{ group }}</span>
        }
      </div>

      <div class="card-bottom">
        <div class="field owner">
          <span class="label">{{ 'CDC_AUTHENTICATION.OWNER' | translate }}</span>
          <span class="value">{{ $owner() || '—' }}</span>
        </div>
        <div class="field expiry">
          <span class="label">{{ 'CDC_AUTHENTICATION.CARD_EXPIRATION' | translate }}</span>
          <span class="value">{{ $expiry() }}</span>
        </div>
      </div>
    </div>

    <div class="card-face card-back">
      <div class="magstripe"></div>
      <div class="signature-row">
        <div class="signature"></div>
        <div class="cvv-box">{{ $cvvDisplay() }}</div>
      </div>
      @if($brandLogo()){
      <img class="brand brand-back" [src]="$brandLogo()" alt="" />
      }
    </div>

  </div>
</div>
